import * as React from "react";
import { StyledSubTitle } from "./components/StyledSubTitle";
import { StyledTitle } from "./components/StyledTitle";
import { Wrapper } from "./components/Wrapper";

export interface ISettingsHeaderDesktop {
  title: string;
  dataE2EId: string;
}

export const SettingsHeaderDesktop = (props: ISettingsHeaderDesktop) => (
  <Wrapper>
    <StyledTitle dataE2EId={props.dataE2EId}>{props.title}</StyledTitle>
  </Wrapper>
);

export const SettingsSubHeaderDesktop = StyledSubTitle;
